import { Injectable } from '@angular/core';
import * as amplifyStore from "amplify-store"

@Injectable({
    providedIn: 'root'
})
export class AmplifyService {

    constructor() {

    }
    SetStorage(key: string, value: any) {
        amplifyStore(key, value);
    }

    GetStorage(key: string) {
        return amplifyStore(key);
    }

    ClearStorage(key: string) {
        amplifyStore(key, null);
    }

    ClearAll() {
        let storageArray = ['jobCardList', 'jobCardList_PageNo', 'jobCardList_PageSize',
            'samplesList', 'samplesList_PageNo', 'samplesList_PageSize',
            'labList', 'labList_PageNo', 'labList_PageSize',
            'customersList', 'customersList_PageNo', 'customersList_PageSize',
            'usersList', 'usersList_PageNo', 'usersList_PageSize',
            'analysisList', 'analysisList_PageNo', 'analysisList_PageSize',
            'productGradesList', 'productGradesList_PageNo', 'productGradesList_PageSize',
            'graphTmpltsList', 'graphTmpltsList_PageNo', 'graphTmpltsList_PageSize',
            'eqpmntsList', 'eqpmntsList_PageNo', 'eqpmntsList_PageSize',
            'lubricantsList', 'lubricantsList_PageNo', 'lubricantsList_PageSize'];
        for (let storageItem of storageArray) {
            this.ClearStorage(storageItem);
        }
    }
}
